<template>
  <div class="modal-wrap modal-wrap--35">
    <div class="modal-header">
      <p class="bold">Ta bort kund från visning</p>
    </div>

    <div class="modal-content pt-15">
      <p class="mb-15">Ska {{ currentCustomer.name }} tas bort från visningen?</p>
    </div>
    <div class="modal-buttons">
      <div class="grid2col">
        <button class="width-100 fg-black" @click="this.$root.abortForm">
          avbryt
        </button>
        <button class="width-100" @click="deleteCustomer">
          TA BORT
        </button>
      </div>
    </div>
    <spinner v-show="loading"/>
  </div>
</template>

<script>
import spinner from '../../spinner';
import Bugsnag from '@bugsnag/js';

export default {
  name: 'deleteShowingsCustomer',
  data() {
    return {
      loading: false
    }
  },
  computed: {
    currentCustomer() {
      return this.$store.state.showing.currentData;
    }
  },
  methods: {
    deleteCustomer() {
      this.loading = true;
      let data = {
        customerId : this.$store.state.showing.currentData.customerId,
        activityShowingId: this.$store.state.showing.currentData.activityShowingId,
        objectShowingId: this.$store.state.showing.currentData.objectShowingId,
      }

      this.$root.callFasAdApi("/internalapi/showing/delete-showing-customer", "DELETE", data)
      .then((data) => {
        this.loading = false;
        this.$root.handleResponseMessage(data);
        this.$root.modalOpen = false;
        this.$store.dispatch('showing/storeShowingDataForSelectedListing', { listingId: this.$route.params.id });
      })
      .catch((error) => {
        Bugsnag.notify(error);
        Bugsnag.notify(data);
      });
    }
  },
  components: {
    spinner
  }
}
</script>
